import { languageMap } from "../core"
import { bracketIndenting } from "./shared"

languageMap.r = bracketIndenting({
	line: "#",
})
